import React from 'react';
import { DropDown } from './common';
import { validatable } from 'components/utils';

class DropDownChonLinhVucThanhTra extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown
        label={this.props.label}
        bindValidator={this}
        name={this.props.name}
        confirm={this.props.confirm}
        channel="formTaoDon"
        require={this.props.require}
        selectedValue={this.props.selectedValue}
        options={this.props.data}
        keyName='giaTri'
        valueName='ten'
        className={this.props.className}
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
      />
    );
  }
}

DropDownChonLinhVucThanhTra.defaultProps = {
  label: 'Lĩnh vực thanh tra',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [
    { giaTri: 'Hành chính', ten: 'Hành chính' },
    { giaTri: 'Đất đai', ten: 'Đất đai' },
    { giaTri: 'XDCB', ten: 'XDCB' },
    { giaTri: 'Chuyên ngành', ten: 'Chuyên ngành' }
  ]
}

export default validatable(DropDownChonLinhVucThanhTra);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonLinhVucThanhTra.jsx